import classNames from "classnames";
import { Button } from "@/components";
import type { ApiDeviceProfile } from "../../_types/device-profiles.types";
import { DeviceProfileListItem } from "../device-profile-list-item";
import styles from "./DeviceProfilesList.module.scss";

type DeviceProfilesListProps = {
  items: ApiDeviceProfile[];
  isLoading: boolean;
  isFetching: boolean;
  isError: boolean;
  onRetry: () => void;
  onRowClick: (id: string) => void;
  onEdit: (profile: ApiDeviceProfile) => void;
  onDuplicate: (profile: ApiDeviceProfile) => void;
  onRequestDelete: (profile: ApiDeviceProfile) => void;
  actionsDisabled: boolean;
};

export const DeviceProfilesList = ({
  items,
  isLoading,
  isFetching,
  isError,
  onRetry,
  onRowClick,
  onEdit,
  onDuplicate,
  onRequestDelete,
  actionsDisabled,
}: DeviceProfilesListProps) => {
  if (isLoading) {
    return (
      <div className={styles["comp__state"]}>
        <div className={styles["comp__spinner"]} />
        <div>Loading profiles…</div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className={styles["comp__state"]}>
        <div>Could not load profiles.</div>
        <Button size="small" variant="secondary" onClick={onRetry}>
          Retry
        </Button>
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className={styles["comp__state"]}>
        No prototype profiles yet. Create one to explore the preview UI (not saved to the API).
      </div>
    );
  }

  return (
    <div className={styles["comp"]} aria-busy={isFetching}>
      <div className={styles["comp__table-header"]}>
        <div className={styles["comp__column"]}>Name</div>
        <div className={styles["comp__column"]}>Version</div>
        <div className={styles["comp__column"]}>Updated</div>
        <div className={classNames(styles["comp__column"], styles["comp__column--actions"])}>Actions</div>
      </div>

      <div className={styles["comp__list"]}>
        {items.map((p) => (
          <DeviceProfileListItem
            key={p.id}
            profile={p}
            onRowClick={() => onRowClick(p.id)}
            onEdit={() => onEdit(p)}
            onDuplicate={() => onDuplicate(p)}
            onRequestDelete={() => onRequestDelete(p)}
            actionsDisabled={actionsDisabled}
          />
        ))}
      </div>
    </div>
  );
};
